import { useTheme } from '@mui/material';
import { StepIconProps } from './StepIcon.props';
import { IconCheck, IconCircle, IconContainer, IconSkeleton } from './StepIcon.styles';
import { getStepAccentColors } from '../getStepAccentColors';
import { StepStatus } from '../ValuationStatusTracker.types';

const StepIcon = ({ status, isLoading = false, accentColor }: StepIconProps) => {
  const theme = useTheme();
  const isDark = theme.palette.mode === 'dark';
  const { activeColor, completedBackground, completedTextColor } = getStepAccentColors(
    accentColor,
    isDark,
    theme.palette.primary.main
  );

  const getIconContent = () => {
    if (isLoading) {
      return <IconSkeleton variant="circular" animation="wave" />;
    }

    switch (status) {
      case StepStatus.COMPLETED:
        return <IconCheck sx={{ color: completedTextColor ?? 'white' }} />;
      case StepStatus.ACTIVE:
        return <IconCircle sx={{ color: activeColor }} />;
      case StepStatus.PENDING:
        return <IconCircle style={{ color: 'white' }} />;
      default:
        return <IconCircle style={{ color: 'white' }} />;
    }
  };

  const getContainerStyle = (): React.CSSProperties | undefined => {
    if (status === StepStatus.COMPLETED && completedBackground) {
      return { backgroundColor: completedBackground, borderColor: completedBackground };
    }
    if (status === StepStatus.ACTIVE) {
      return { borderColor: activeColor, color: activeColor };
    }
    return undefined;
  };

  return (
    <IconContainer className={status} style={getContainerStyle()}>
      {getIconContent()}
    </IconContainer>
  );
};

export default StepIcon;
